import Dashboard from "layouts/dashboard";
import UserProfile from "layouts/user-profile";
import Login from "auth/login";
import Register from "auth/register";
import ForgotPassword from "auth/forgot-password";
import ResetPassword from "auth/reset-password";
// @mui icons
import Icon from "@mui/material/Icon";
import KarkunManagement from "layouts/karkun-management";
import CenterManagement from "layouts/Center-management";
import MeetingManagement from "layouts/Meeting-management";
import AttendanceManagement from "layouts/Attendance-management";
import RolesManagement from "layouts/roles-management";
import FundsManagement from "layouts/Funds-management";


const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "examples",
    name: "Centers",
    key: "centers",
    icon: <Icon fontSize="small">engineering</Icon>,
    route: "/centers",
    permissions: ["center:view", "center:all"],

    component: <CenterManagement />,
  },
  {
    type: "examples",
    name: "Karkuns",
    key: "karkuns",
    icon: <Icon fontSize="small">contacts</Icon>,
    route: "/karkuns",
    permissions: ["karkun:view", "karkun:all"],
    component: <KarkunManagement />,
  },
  {
    type: "examples",
    name: "Meeting",
    key: "meeting",
    icon: <Icon fontSize="small">meeting_room</Icon>,
    route: "/meeting",
    permissions: ["meeting:view", "meeting:all"],
    component: <MeetingManagement />,
  },
  {
    type: "examples",
    name: "Attendance",
    key: "attendance",
    icon: <Icon fontSize="small">present_to_all</Icon>,
    route: "/attendance",
    permissions: ["attendance:view", "attendance:all"],
    component: <AttendanceManagement />,
  },
    {
    type: "examples",
    name: "Funds",
    key: "funds",
    icon: <Icon fontSize="small">attach_money</Icon>,
    route: "/funds",
    permissions: [],
    component: <FundsManagement />,
  },
  {
    type: "examples",
    name: "Roles",
    key: "roles",
    icon: <Icon fontSize="small">lock_person</Icon>,
    route: "/roles",
    permissions: ["roles:view", "roles:all"],
    component: <RolesManagement />,
  },
  {
    type: "examples",
    name: "User Profile",
    key: "user-profile",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    route: "/user-profile",
    permissions: [],
    component: <UserProfile />,
  },
  {
    type: "auth",
    name: "Login",
    key: "login",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/auth/login",
    component: <Login />,
  },

  {
    type: "auth",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/forgot-password",
    component: <ForgotPassword />,
  },
  {
    type: "auth",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/auth/reset-password",
    component: <ResetPassword />,
  },
];

export default routes;